import React from "react"
import BigCalendar from "react-big-calendar"
import moment from "moment"
import MonthEvent from "./MonthEvent"
import strings from "../../../localization/strings"
import { green500, blue500, grey500, red500 } from "material-ui/styles/colors"
import { IJobInfo, IUserJobSearch } from "../../../models"
import * as timeHelper from "../../../helpers/timeHelper"
import * as utils from "../../../helpers/utils"
import "react-big-calendar/lib/css/react-big-calendar.css"
import "./styles.css"

interface IProps {
  jobs: IUserJobSearch[]
  refereceDate: Date
  milesFilter: boolean
}

interface IState {
	jobInfo: IJobInfo
	previouslyFetchedJobId: string
}

export default class UserJobCalendarView extends React.Component<IProps, IState> {

  constructor(props){
    super(props)
    this.state = {
      jobInfo: undefined,
			previouslyFetchedJobId: undefined,
    }
  }

  render() {
    const monthStartDate = moment(this.props.refereceDate).startOf("month").format()
    const monthEndDate = moment(this.props.refereceDate).endOf("month").format()

    const events = []
    this.props.jobs.forEach(item => {
      const timeoffEndDate = moment(item.EndDate).format()
      let date = timeHelper.keepConvertUTCToLocal(item.StartDate)

      while (moment(date).isBefore(timeoffEndDate)) {
        if (moment(date).isSameOrAfter(monthStartDate) && moment(date).isBefore(monthEndDate)) {
          events.push({
            start: moment(date).toDate(),
            end: moment(date).toDate(),
            jobName: item.JobName,
            jobId: item.Id,
            elId: utils.guid(),
            jobInfo: this.state.jobInfo,
            status: item.Requested ? blue500 : item.Available ? grey500 : item.ConfirmedWork ? green500 : red500,
            distanceToJob: this.props.milesFilter ? `${item.Distance} ${strings.Miles.toLowerCase()}` : "",
            setJobInfo: (jobInfo) => this.setState({ jobInfo }),
            previouslyFetchedJobId: this.state.previouslyFetchedJobId,
            setPreviouslyFetchedJobId: (previouslyFetchedJobId) => this.setState({ previouslyFetchedJobId }),
          })
        }
        date = moment(date).add(1, "day").format()
      }
    })
    return (
      <div>
        <BigCalendar
          popup
          views={{ month: true, week: false }}
          defaultView={BigCalendar.Views.MONTH}
          step={60}
          className={"Job-container"}
          localizer={BigCalendar.momentLocalizer(moment)}
          events={events}
          defaultDate={this.props.refereceDate}
          eventPropGetter={() => ({ className: "Job-Event-Node" })}
          toolbar={false}
          components={{
            month: { event: MonthEvent }
          }}
        />
      </div>
    )
  }
}
